import React from 'react';
import { AccessDenied } from '../pages/admin/AccessDenied';

// Role definitions - must match backend and AdminDashboard.jsx
const ROLES = {
  OWNER: 'OWNER',
  SHOP_MANAGER: 'SHOP_MANAGER'
};

/**
 * ProtectedRoute - Wraps routes that require specific roles
 * 
 * Usage:
 * <Route path="users" element={
 *   <ProtectedRoute allowedRoles={['OWNER']}>
 *     <AdminUsersManager />
 *   </ProtectedRoute>
 * } />
 */
export const ProtectedRoute = ({ children, allowedRoles = [ROLES.OWNER, ROLES.SHOP_MANAGER] }) => {
  // Get current user role from localStorage (set during login/verify)
  const userRole = localStorage.getItem('admin_role') || ROLES.OWNER;
  
  // Check if user's role is in allowed roles
  const hasAccess = allowedRoles.includes(userRole);
  
  if (!hasAccess) {
    return <AccessDenied />;
  }
  
  return children;
};

// Export roles for use in other components
export { ROLES };
